<template>
  <div class="downloads">
    <div class="container py-5">
      <h1 class="text-center mb-5">{{ t('downloads.title') }}</h1>

      <div class="row mb-5">
        <div class="col-md-6 mx-auto">
          <div class="card text-center p-4">
            <h2>{{ t('downloads.excelAddin.title') }}</h2>
            <p>{{ t('downloads.excelAddin.description') }}</p>

            <!-- Show loading state while fetching data -->
            <div v-if="loading" class="text-center my-4">
              <div class="spinner-border text-success" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>

            <div v-else-if="error" class="alert alert-danger">
              <p class="text-danger">{{ t('downloads.errors.failedToLoad') }}</p>
              <button @click="fetchDownloadInfo" class="btn btn-outline-danger">
                {{ t('downloads.retry') }}
              </button>
            </div>

            <div v-else>
              <p>
                <a :href="downloadInfo.addin_installer_url" class="btn btn-success py-2 px-5" target="_blank">
                  {{ t('downloads.excelAddin.download') }}
                </a>
              </p>
              <p v-if="downloadInfo.addin_version">
                <strong>{{ t('downloads.excelAddin.version') }}:</strong> {{ downloadInfo.addin_version }}
              </p>
              <p v-if="downloadInfo.addin_date">
                <strong>{{ t('downloads.excelAddin.lastUpdated') }}:</strong> {{ downloadInfo.addin_date }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="row mb-5">
        <div class="col-md-6 mx-auto">
          <div class="card text-center p-4">
            <h2>{{ t('downloads.desktopHelper.title') }}</h2>
            <p>{{ t('downloads.desktopHelper.description') }}</p>

            <!-- Show loading state while fetching data -->
            <div v-if="loading" class="text-center my-4">
              <div class="spinner-border text-success" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>

            <div v-else-if="error" class="alert alert-danger">
              <p class="text-danger">{{ t('downloads.errors.failedToLoad') }}</p>
              <button @click="fetchDownloadInfo" class="btn btn-outline-danger">
                {{ t('downloads.retry') }}
              </button>
            </div>

            <div v-else>
              <div class="d-flex justify-content-center gap-3 mb-3">
                <a :href="downloadInfo.desktop_helper_installer_url" class="btn btn-success px-3 py-2" target="_blank">
                  <i class="fab fa-windows me-2"></i>{{ t('downloads.desktopHelper.downloadWindows') }}
                </a>
                <a :href="downloadInfo.mac_helper_installer_url" class="btn btn-success px-3 py-2" target="_blank">
                  <i class="fab fa-apple me-2"></i>{{ t('downloads.desktopHelper.downloadMac') }}
                </a>
              </div>
              <p v-if="downloadInfo.desktop_helper_version" class="mb-1">
                <small><strong>Windows:</strong> v{{ downloadInfo.desktop_helper_version }}</small>
              </p>
              <p v-if="downloadInfo.mac_helper_version">
                <small><strong>macOS:</strong> v{{ downloadInfo.mac_helper_version }}</small>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 mx-auto">
          <div class="card text-center p-4">
            <h2>{{ t('downloads.mobileApp.title') }}</h2>
            <p>{{ t('downloads.mobileApp.description') }}</p>
            <div class="d-flex justify-content-center gap-3 my-3">
              <a :href="downloadInfo.ios_app_url" class="btn btn-dark px-3 py-2" target="_blank">
                <i class="fab fa-apple me-2"></i> {{ t('downloads.mobileApp.appStore') }}
              </a>
              <a :href="downloadInfo.android_app_url" class="btn btn-dark px-3 py-2" target="_blank">
                <i class="fab fa-google-play me-2"></i> {{ t('downloads.mobileApp.googlePlay') }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {useI18n} from 'vue-i18n'
import downloadsService from '@/services/downloadsService';

export default {
  name: 'DownloadsView',
  setup() {
    const {t, locale} = useI18n()
    return {t, locale}
  },
  data() {
    return {
      loading: true,
      error: null,
      downloadInfo: {
        addin_version: '',
        addin_date: '',
        addin_installer_url: '#',
        desktop_helper_version: '',
        desktop_helper_date: '',
        desktop_helper_installer_url: '#',
        mac_helper_version: '',
        mac_helper_date: '',
        mac_helper_installer_url: '#',
        ios_app_url: 'https://apps.apple.com/gb/app/ct-grid/id1511953357',
        android_app_url: 'https://play.google.com/store/apps/details?id=com.ctgrid'
      }
    }
  },
  methods: {
    fetchDownloadInfo() {
      this.loading = true;
      this.error = null;

      downloadsService.getDownloadsInfo()
          .then(response => {
            console.log('Download info response:', response.data);
            this.downloadInfo = response.data;
            this.loading = false;
          })
          .catch(error => {
            console.error('Error fetching download information:', error);
            this.error = error;
            this.loading = false;
          });
    }
  },
  created() {
    this.setPageTitle(this.t('downloads.title'));
    this.fetchDownloadInfo();
  }
}
</script>